import { useScrollTo } from '@bluheadless/ui-logic/src/hooks/useScrollTo.js'
import { cx } from '@emotion/css'
import { string } from 'prop-types'
import { useCallback, useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { Root } from './skip-link.styled.js'

const SkipLink = ({ target = 'main' }) => {
	const { formatMessage } = useIntl()
	const mainContentRef = useRef(null)
	const skipLinkRef = useRef(null)
	const { manageScroll } = useScrollTo()

	useEffect(() => {
		// get first focusable element in the main content
		const mainContent = document.querySelector(`#${target}`)
		if (mainContent) {
			// FIXME: this is a workaround since the main content seems to not be focusable sometimes
			// and we need to find the first focusable element inside it.
			const focusableElements = mainContent.querySelectorAll(
				'a, input, select, textarea, button, [tabindex]:not([tabindex="-1"]), [contenteditable]'
			)
			if (focusableElements.length > 0) {
				mainContentRef.current = focusableElements[0]
			} else {
				mainContentRef.current = mainContent
			}
		}
	}, [target])

	// Handle keyboard events for accessibility
	const handleAction = useCallback(
		(e) => {
			if ((e.type === 'keydown' && (e.key === 'Enter' || e.keyCode === '13' || e.key === ' ')) || e.type === 'click') {
				e.preventDefault()
				if (mainContentRef.current) {
					setTimeout(() => {
						// Remove focus from the skip link
						skipLinkRef.current.blur()
						// Focus on the target element
						mainContentRef.current.focus()
					}, 100)
					// Scroll to the target element
					manageScroll({
						ref: mainContentRef,
						offset: 100, // minimum offset to account for fixed headers
					})
				}
			}
		},
		[manageScroll]
	)

	return (
		<Root
			className={cx('SkipLink-root', 'skip-link')}
			onKeyDown={handleAction}
			onClick={handleAction}
			href={`#${target}`}
			ref={skipLinkRef}
		>
			{formatMessage({ id: 'skip_to_content' })}
		</Root>
	)
}

SkipLink.propTypes = {
	/** The id of the target element to skip to */
	target: string,
}

export default SkipLink
